import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
import { LOGO_URL } from '../data/navigation';
export function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);
  return <main className="min-h-screen w-full flex bg-stark-white" data-id="element-312" data-mp="2fno5t9s4rg6d">
      {/* Left Side - Form */}
      <div className="flex-1 flex flex-col justify-center px-6 py-12 lg:px-20 xl:px-32 relative" data-id="element-313" data-mp="33ds554yactrk">
        <Link to="/" className="absolute top-8 left-6 lg:left-20 xl:left-32" data-id="element-314" data-mp="38dej5glxue1f">
          <img src={LOGO_URL} alt="ROI Complete" className="h-12 md:h-14 w-auto" data-id="element-315" data-mp="2toid1p3fzb3g" />
        </Link>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="w-full max-w-md mx-auto" data-id="element-316" data-mp="2yn20xv1liwyg">
          <div className="space-y-2 mb-10" data-id="element-317" data-mp="3r3crzyxk8b64">
            <h1 className="text-3xl md:text-4xl font-montserrat font-extrabold text-midnight-navy tracking-tight" data-id="element-318" data-mp="3r57cxd8u03a7">
              Welcome back
            </h1>
            <p className="text-midnight-navy/60" data-id="element-319" data-mp="2mihilw1srjy2">
              Log in to access your operational intelligence dashboard.
            </p>
          </div>

          <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-320" data-mp="3186o23gxaa45">
            <div className="space-y-2" data-id="element-321" data-mp="2wfdhrb5t2tpy">
              <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/60 ml-1" data-id="element-322" data-mp="2weapozwqyl8g">
                Email Address
              </label>
              <input required type="email" className="w-full px-5 py-4 bg-cool-gray border border-midnight-navy/10 rounded-xl focus:outline-none focus:border-royal-blue transition-colors" placeholder="name@company.com" data-id="element-323" data-mp="357nrysgpaz77" />
            </div>

            <div className="space-y-2" data-id="element-324" data-mp="1prys4kvzxx1g">
              <div className="flex items-center justify-between ml-1" data-id="element-325" data-mp="1ksvkqtsjneqb">
                <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/60" data-id="element-326" data-mp="1kuow2me3qn4n">
                  Password
                </label>
                <a href="#" className="text-xs font-bold text-royal-blue hover:text-royal-blue-dark transition-colors" data-id="element-327" data-mp="2ehl0j3qjyeug">
                  Forgot password?
                </a>
              </div>
              <div className="relative" data-id="element-328" data-mp="2oefvjcnm9x3z">
                <input required type={showPassword ? 'text' : 'password'} className="w-full px-5 py-4 bg-cool-gray border border-midnight-navy/10 rounded-xl focus:outline-none focus:border-royal-blue transition-colors pr-12" placeholder="••••••••" data-id="element-329" data-mp="2tg55eoz3s4qh" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-midnight-navy/40 hover:text-midnight-navy transition-colors" data-id="element-330" data-mp="376ickp467fer">
                  {showPassword ? <EyeOffIcon className="w-5 h-5" data-id="element-331" data-mp="15frqqk2jvelx" /> : <EyeIcon className="w-5 h-5" data-id="element-332" data-mp="10h6oyg7ngmvd" />}
                </button>
              </div>
            </div>

            <button type="submit" className="w-full bg-royal-blue text-stark-white py-4 rounded-xl font-bold hover:bg-royal-blue-dark transition-all shadow-lg shadow-royal-blue/20 flex items-center justify-center gap-2 group" data-id="element-333" data-mp="vlhw0vq4y481">
              Log In
              <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-334" data-mp="1jbc6j6mzfgp4" />
            </button>
          </form>

          <p className="mt-8 text-center text-midnight-navy/60 text-sm" data-id="element-335" data-mp="19jzg8jgu0yl7">
            Don't have an account?{' '}
            <Link to="/signup" className="font-bold text-royal-blue hover:text-royal-blue-dark transition-colors" data-id="element-336" data-mp="26z3ninjgwhwq">
              Sign up
            </Link>
          </p>
        </motion.div>
      </div>

      {/* Right Side - Image/Testimonial */}
      <div className="hidden lg:flex flex-1 bg-midnight-navy relative overflow-hidden items-center justify-center p-12" data-id="element-337" data-mp="1rpq5jr54gi0l">
        <div className="absolute inset-0 opacity-40" data-id="element-338" data-mp="1cszatv6e7uhb">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/e1434989-ade5-4a3c-bbcf-b7c2249a9c9a.jpg" alt="Dashboard Background" className="w-full h-full object-cover" data-id="element-339" data-mp="1hr0x0oz489x0" />
          <div className="absolute inset-0 bg-midnight-navy/80 mix-blend-multiply" data-id="element-340" data-mp="2afy4ry5paobi" />
        </div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative z-10 max-w-lg space-y-8" data-id="element-341" data-mp="1vrjyfd92shq7">
          <div className="w-12 h-12 bg-royal-blue rounded-xl flex items-center justify-center shadow-xl shadow-royal-blue/20" data-id="element-342" data-mp="2odweurcznyl7">
            <svg className="w-6 h-6 text-stark-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-343" data-mp="2t80mlcu2wanc">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-344" data-mp="cru7nl5gfsbn" />
            </svg>
          </div>
          <blockquote className="text-3xl font-montserrat font-bold text-stark-white leading-tight" data-id="element-345" data-mp="mk9qslshmmy4">
            "ROI Complete gave us visibility we never had. Within one quarter we
            cut food cost by three points."
          </blockquote>
          <div data-id="element-346" data-mp="7u2eyowzk26e">
            <div className="text-stark-white font-bold" data-id="element-347" data-mp="7ukmihp3m2tm">Denise Carter</div>
            <div className="text-stark-white/60 text-sm" data-id="element-348" data-mp="3r61tdq7sy9u">
              Owner, Union Square Kitchens
            </div>
          </div>
        </motion.div>
      </div>
    </main>;
}